export default __webpack_public_path__ + "static/media/salad-map-dot.03036eac.svg";